export enum EDevelopmentState {
  NEW = 'NEW', UPLOADED = 'UPLOADED', RELEASED = 'RELEASED', CANCELED = 'CANCELED'
}
